import { WebApiRequest, HTTP_GET } from "tools/webservice";
import {TopicResponse} from "../cms/interfaces.ts";
import {Ref} from "react";

export const getHelpTopicSession = (topicId: string, host: string, sessionId: string, successCallback: (resp: TopicResponse) => void, mountedRef: Ref<boolean>) =>
        WebApiRequest({
          method: HTTP_GET,
          endpoint: `${host}/services/forms4/content-library/topic/${topicId}/${sessionId}`,
          successCallback,
          mountedRef,
          skipAuthorization: true,
        });

export const getHelpTopicMarkupSession = (topicId: string, host: string, sessionId: string, successCallback: (markup: string) => void, mountedRef: Ref<boolean>) =>
        WebApiRequest({
          method: HTTP_GET,
          endpoint: `${host}/services/forms4/content-library/topic/${topicId}/markup/${sessionId}`,
          successCallback,
          mountedRef,
          skipAuthorization: true,
        });

export const getHelpTopicByKeySession = (topicKey: string, host: string, sessionId: string, successCallback: (resp: TopicResponse) => void, mountedRef: Ref<boolean>) =>
        WebApiRequest({
          method: HTTP_GET,
          endpoint: `${host}/services/forms4/content-library/topic-key/${topicKey}/${sessionId}`,
          successCallback,
          mountedRef,
          skipAuthorization: true,
        });

export const getHelpTopicMarkupByKeySession = (topicKey: string, host: string, sessionId: string, successCallback: (markup: string) => void, mountedRef: Ref<boolean>) =>
        WebApiRequest({
          method: HTTP_GET,
          endpoint: `${host}/services/forms4/content-library/topic-key/${topicKey}/markup/${sessionId}`,
          successCallback,
          mountedRef,
          skipAuthorization: true,
        });
